import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as BeaconService from "_services/beacons-service";

// initial state of slice
const initialState = {
    airportUuid: null,
    airportCoordinates: {},
    tenant: null,
    loading: false,
    error: null,
};

export const getAirportUuidAndCoordinates = createAsyncThunk(
    "beacons/getUuidAndCoordinates",
    async (params) => {
        return BeaconService.getUuidAndCoordinates(params);
    }
);

const timelineControlSlice = createSlice({
    name: "timelineLiveLocationTab",
    initialState,
    reducers: {
        reset: (state) => {
            state.airportUuid = null;
            state.airportCoordinates = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAirportUuidAndCoordinates.pending, (state) => {
                state.airportUuid = null;
                state.airportCoordinates = {};
                state.tenant = null;
                state.loading = true;
                state.error = null;
            })
            .addCase(getAirportUuidAndCoordinates.fulfilled, (state, action) => {
                state.airportUuid = action.payload.uuid;
                state.airportCoordinates = action.payload.coordinates;
                state.tenant = action.payload.tenant;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAirportUuidAndCoordinates.rejected, (state, action) => {
                state.airportUuid = null;
                state.airportCoordinates = {};
                state.tenant = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const SelectAirportUuid = (state) => state.timelineLiveLocationTab.airportUuid;
export const SelectCurrentCoordinates = (state) => state.timelineLiveLocationTab.airportCoordinates;
export const SelectTenant = (state) => state.timelineLiveLocationTab.tenant;

export const { reset } = timelineControlSlice.actions;
export default timelineControlSlice.reducer;
